"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference path="../lib/phaser.d.ts"/>
const Phaser = require("phaser");
const boot_ts_1 = require("./states/boot.ts");
class Game extends Phaser.Game {
    constructor() {
        let width = document.documentElement.clientWidth > 768 ? 768 : document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight > 1024 ? 1024 : document.documentElement.clientHeight;
        super(width, height, Phaser.AUTO, 'content', null);
        this.state.add('Boot', boot_ts_1.BootState, false);
        this.state.start('Boot');
    }
}
new Game();



//////////////////
// WEBPACK FOOTER
// ./src/index.ts
// module id = 1
// module chunks = 0